import style from "./entrystyle.module.css";
import Form from "../Form";
import { useState, useEffect } from "react";
import {domain} from "config.js";

function DataEntry() {
    const [tarfol, setTarFol] = useState("");

    useEffect(() => {
        (async () => {
            setTarFol(await (await fetch(domain + "/int-generateName")).text());
        })()
    }, []);

    return (
        <div className="container-fluid">

            <div className={`row ${style.header} bg-primary text-white ${style.header}`}>
                <div className={style.title}>
                    <h1 className={style.titleHeader}>Welcome to data entry</h1>
                </div>

                <div className={`${style.headerText}`}>
                    <p >Here you can add new properties to website.</p>
                    <p >The data you fill here, including the images you upload will be saved for a single property that will be created
                        when you save.</p>
                </div>
            </div>

            <div className="row">
                <div className="col d-flex justify-content-center">
                    <Form className="col-sm-12 col-md-8" tarfol={tarfol} />
                </div>
            </div>

        </div>
    );
}

export default DataEntry;